var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');

require('./_styles.scss');
require('angular-ui-router');
require('../home/contact-agent-lo');
require('../home/contact-agent-lo/form');
require('../../services/agent-nav-store');
require('../../services/vendor-nav-store');
require('../../services/branded-nav');
require('../../services/error-modal');
require('../../services/user');
require('../../filters');

_module.requires.push(
    'ui.router'
);

_module.controller('BrandednavStaticpageCtrl', [
    '$log',
    '$scope',
    '$timeout',
    '$agentNavStore',
    '$vendorNavStore',
    '$stateParams',
    '$errorModal',
    '$user',
    '$brandedNav',

    function BrandednavStaticpageCtrl($log, $scope, $timeout, $agentNavStore, $vendorNavStore, $stateParams, $errorModal, $user, $brandedNav) {
        $log.debug('BrandednavStaticpageCtrl', this);

        var vm = this;
        vm.model = {
            affiliate: undefined,
            page: undefined
        };

        // Life Cycle Hooks
        vm.$onInit = init;

        // Functions
        function fetchPage() {
            var $store = $user.affiliate.vendorId ? $vendorNavStore : $agentNavStore;

            $store.get($stateParams.pageId)
            .then(function (response) {
                vm.model.page = response;
                vm.model.affiliate = response.content.affiliate_to_display === 'agent' ? $user.affiliate : ($user.affiliate.benoit_partner || $user.affiliate);
            })
            .catch(function () {
                $errorModal();
            });
        }

        function init() {
            // Hide Additional Nav items we dont need
            $brandedNav.hide('latestVideos', 'featuredProperties', 'meetTheTeam');

            fetchPage();
        }
    }
]);

_module.component('brandednavStaticpage', {
    controllerAs: 'vm',
    controller: 'BrandednavStaticpageCtrl',
    template: require('./index.html')
});
